
var mChartingCalendarColors = {
    "In Motion (i.e., Trip)": "#a69d7c",
    "Home": "#00e573",
    "Other": "#6f8197",
    "Work": "#0a5247",
    "Home In Progress": "#19e781",
    "Other In Progress": "#8b9aab",
    "Work In Progress": "#3a746b",
    "Visit Not Labeled": "#FF9966",
    "Visit Not Labeled In Progress": "#e5895b",
    "Labeled Visit": "#0039ae",
    "Labeled Visit In Progress": "#e5895b",
    //"Suggested Visit": "#0099cc",
    "No Location Area": "#FFFFFF"
}

var mSoberTrackLiveBlockCharting = {
    1: "Images/soberTrackBlockConfirm",
    0: "Images/soberTrackBlockConfirmFalse",
}

var mSoberTrackLiveTestResultCharting = {
    'pu': "Images/Events/1000",
    'pi': "Images/Events/1001",
    'pm': "Images/Events/1002",
    'fu': "Images/Events/1003",
    'fm': "Images/Events/1004",
    'fi': "Images/Events/1005",
    'u': "Images/Events/1006",
    'i': "Images/Events/1007",
}

var mSoberTrackLiveTestResultMapping = {
    'pu': "Images/Maps/Trackpoints/1000",
    'pi': "Images/Maps/Trackpoints/1001",
    'pm': "Images/Maps/Trackpoints/1002",
    'fu': "Images/Maps/Trackpoints/1003",
    'fm': "Images/Maps/Trackpoints/1004",
    'fi': "Images/Maps/Trackpoints/1005",
    'u': "Images/Events/1006",
    'i': "Images/Events/1007",

}

var mChartingCalendarEventIcons = {
    1003: "Images/Maps/Cards/10100001",
    1001: "Images/Maps/Cards/10100001",
    16: "Images/Maps/Cards/10100100",
    20: "Images/Maps/Cards/10101000",
    10: "Images/Maps/Cards/10110000",
    13: "Images/Maps/Cards/10100010",
    196: "Images/Maps/Cards/shielding",
    371: "Images/Maps/Cards/jamming",
    63: "Images/satellitedark16",
    383: "Images/BatteryState6Dark",
    2001: "Images/Maps/Cards/Correlate16",
    2002: "Images/Maps/Cards/Correlate16KnownLocation"
}

var mMappingEventIcons = {
    1003: { light: "10100001", regular: "10100001" },
    1001: { light: "10100001", regular: "10100001" },
    16: { light: "10100100", regular: "10100100" },
    20: { light: "10101000", regular: "10101000" },
    27: { light: "MessageGapLight", regular: "MessageGap" },
    10: { light: "10110000", regular: "10110000" },
    13: { light: "10100010", regular: "10100010" },
    196: { light: "shielding", regular: "shielding" },
    371: { light: "jamming", regular: "jamming" },
    63: { light: "SatelliteLight", regular: "Satellite" },
    2001: { light: "Correlate16", regular: "Correlate16" },
    2002: { light: "Correlate16KnownLocation", regular: "Correlate16KnownLocation" }
}

function DataObjectBaseClass(){
    /**
     * @param  {} aObject { FirstName:'John' }
     */
    this.setValues = function(aObject){
        for(var k in aObject){
            this[k]= aObject[k];
        }
    };
    this.ConstructorName = function(){
        return this.constructor.name
    };
    this.Save = function(aOnSuccess,aParam){
        WriteSingle(this, aOnSuccess, Sad, aParam, true);
    };
    this.Read = function(aOnSuccess,aParam){
        // "use strict";
        if(this.Id == -1) throw 'no Id found in the'+this.ConstructorName()+' instance ';
        if(!gObjectList[this.ConstructorName()]) throw this.ConstructorName()+' not declared in gObjectList';
        var lBuilder = new SumoPredicateBuilder();
        lBuilder.AddNewExpressionConditional('Id', this.Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        ReadMultiple(gObjectList[this.ConstructorName()].AssemblyQualifiedName, lBuilder.RootExpression, 0, aOnSuccess,Sad, this.Id, aParam, 0);
    };
    this.Proc = function(_aOnSuccess){
        // "use strict";
        var _this = this;
        if(this.Id == -1) throw 'no Id found in the'+this.ConstructorName()+' instance ';
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
        if (!isNullOrUndefined(lSecurityToken)) {
            callAjax('Get'+_this.ConstructorName(), {
                'aSecurityToken': lSecurityToken,
                'aId': _this.Id,    
            }, _aOnSuccess, Sad, null, false);
        }
    };
    this.Post = function(_aOnSuccess){
        var _this = this;
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
        if (!isNullOrUndefined(lSecurityToken)) {
            callAjax('Victims', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aVictim': _this
            }, _aOnSuccess, Sad, null);
        }
    }
}

if (typeof exports !== 'undefined') {
    module.exports = {
        mChartingCalendarColors,
        mSoberTrackLiveBlockCharting,
        mSoberTrackLiveTestResultCharting,
        mSoberTrackLiveTestResultMapping,
        mChartingCalendarEventIcons,
        mSoberTrackLiveTestResultMapping,
        mMappingEventIcons,
        DataObjectBaseClass
    };
}